
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/lookback",
      function () {
        return require("private-next-pages/about/lookback/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/lookback"])
      });
    }
  